import React from 'react';

export const IconBank = ({ color }) => (
  <svg width="48" height="48" viewBox="0 0 48 48" >
    <path d="M4 40h40v4H4v-4zm4-16h4v14H8V24zm10 0h4v14h-4V24zm8 0h4v14h-4V24zm10 0h4v14h-4V24zM4 14 24 4l20 10v8H4v-8zm4 2.472V18h32v-1.528l-16-8-16 8zM24 16a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
      fill={color} fillRule="evenodd"/>
  </svg>
);
